
function handleErrors(response) {
    if (!response.ok) {
        throw response.json();
    }
    return response.json();
}

export default handleErrors;


// WEBPACK FOOTER //
// ./src/components/utils/handleErrors.js